import { render, staticRenderFns } from "./PlantaoAccess.vue?vue&type=template&id=7caa44c3&scoped=true"
import script from "./PlantaoAccess.vue?vue&type=script&lang=js"
export * from "./PlantaoAccess.vue?vue&type=script&lang=js"
import style0 from "./PlantaoAccess.vue?vue&type=style&index=0&id=7caa44c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caa44c3",
  null
  
)

export default component.exports